// var apiEndPoint = "https://services.yankeekicks.com/userauth_dev/";
var apiEndPoint = "https://api.yankeekicks.com/v1/userauth/";
var crownRedImg = "https://cdn.shopify.com/s/files/1/0702/0052/5105/files/CrownRed.png?v=1706694518";
var crownGoldImg = "https://cdn.shopify.com/s/files/1/0702/0052/5105/files/CrownGold.png?v=1706694518";
var crownPlatinumImg = "https://cdn.shopify.com/s/files/1/0702/0052/5105/files/CrownPlatinum.png?v=1706694518";
var crownPlatinumProImg = "https://cdn.shopify.com/s/files/1/0702/0052/5105/files/CrownPlatinumPro.png?v=1706694518";
var tiers = [];
var buyerObject = {};
var pointsHistory = [];
var stores = [];
var dataTable = initializeDataTable();
loadTiers();
loadCurrentUserTier();
loadStores();
loadPointsHistory(dataTable);

async function loadTiers() {
    try {
        const response = await fetch(apiEndPoint + "buyerLoyalty/all-tiers/"+email);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        let data = await response.json();
        tiers = data;
        tiers.forEach(addImageSrc);
        tiers.reverse();
        tiers.forEach(function (tier, index, array) {
        let textToShow;
        let currentTier="";
        let tierActiveClassName = "";
        if(tier.currentTier){
          currentTier = `<p class="text-muted">Current Tier</p>`;
          tierActiveClassName = "currentTier";
        }
        if (index === array.length - 1) {
          textToShow = "Default";
        } else if (index === 0) {
          // For the last index, show only tier.thresholdPoints
          textToShow = formatNumber(tier.thresholdPoints) + '+ Points';
        } else {
          // For all indices other than the first and last
          const nextThreshold = array[index - 1].thresholdPoints;
          textToShow = `${formatNumber(tier.thresholdPoints)} - ${formatNumber(nextThreshold - 1)} Points`;
        }
        document.querySelector('#tierList').insertAdjacentHTML('beforeend',
          `<li class="timeline-item mb-5">
            <span class="timeline-icon ${tierActiveClassName}">
              <img src="${tier.imageSrc}" class="exp-loaded">
            </span>
            <div class="timeline-sub-content">
              <div class="timeline-sub-content yk-d-flex">
                <div>
                  <h5 class="fw-bold">${tier.tierName}</h5>
                  ${currentTier}
                  <p class="text-muted">${textToShow}</p>
                </div>
                <div class="points-def">
                  <!-- You may want to replace these static values with dynamic ones -->
                  <p class="text-muted">${tier.multiplyFactor}x</p>
                  <p class="text-muted">$1 = ${tier.multiplyFactor}</p>
                  <p class="text-muted">Points</p>
                </div>
              </div>
            </div>
          </li>`
        );
      });
    } catch (error) {
        console.error('Error during fetch:', error);
    }
}

async function loadCurrentUserTier() {
    try {
        const response = await fetch(apiEndPoint + "buyerLoyalty/points-details/" +email);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        let data = await response.json();
        buyerObject = data;
        addImageSrc(buyerObject);
        let buyerEligiblePoints = buyerObject.buyerEligiblePoints || 0;
        if(buyerEligiblePoints == 0){
          document.getElementById("redeem-point-home-btn").disabled = true;
        }
        document.getElementById("currentuser-tier-section").classList.add(addColorTier(buyerObject));
        document.querySelector('#currentPoints').innerHTML = formatNumber(buyerEligiblePoints);
        document.querySelector('#currentTierName').innerHTML = buyerObject.tierName || 'Red';
        document.querySelector('#currentTierImage').src = buyerObject.imageSrc || crownRedImg;
        let pointNeedsToReachNxtLvl = formatNumber((buyerObject.nextTierPoints || 0) - buyerEligiblePoints);
        document.querySelector('#earnMoreInfoText').innerHTML = `Earn ${pointNeedsToReachNxtLvl} points more to reach to ${buyerObject.nextTierName} tier`;
        document.querySelector('#hint-buyerEligiblePoints').innerHTML = `You are eligible to redeem ${buyerObject.buyerEligiblePoints} points only`;
        if(buyerObject.tierName == 'PlatinumPro' || buyerObject.tierName == 'Platinum Pro'){
          document.querySelector('#earnMoreInfoText').style.display = 'none';
        }
    } catch (error) {
        console.error('Error during fetch:', error);
    }
}
async function loadStores() {
    try {
        const response = await fetch(apiEndPoint + "buyerLoyalty/get-stores");
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        let data = await response.json();
        stores = data;
        stores.forEach(function(item, index, array) {
          $('#location-dropdown').append($('<option>').val(item.storeId).text(item.storeName));
        });
    } catch (error) {
        console.error('Error during fetch:', error);
    }
}
// Function to load data into DataTable
function loadPointsHistory(dataTable) {
$.get(apiEndPoint + "buyerLoyalty/points-history/"+email, function(data) {
    $.each(data, function(index, item) {
        // Determine the transaction type and text
        var transactionText = ((item.transactionType).toLowerCase() === 'credit') ? 'Earned' : 'Redeemed';

        // Determine the color class for points
        var pointsColorClass = ((item.transactionType).toLowerCase() === 'credit') ? 'green' : 'red';
        var orderIdOrDescription = item.orderNumber ? item.orderNumber : item.description;

        var row = [
            orderIdOrDescription +`<span class="copy-container"></span>`,
            '<img src="https://cdn.shopify.com/s/files/1/0702/0052/5105/t/6/assets/Medal.png?v=1706887469">' +transactionText,
            formatIngDate(item.createdAt),
            '<span class="' + pointsColorClass + '">' + (((item.transactionType).toLowerCase() === 'credit') ? '+' : '-') + item.points + '</span>',
            // '<a href="" class="view-btn" data-id="' + item.orderId + '">View</a>'
        ];

        // Add the row to DataTable
        dataTable.row.add(row).draw();
    });
});
}

// Function to format date in a readable format
function formatIngDate(dateString) {
    const options = {year:"numeric", month:"short", day:"numeric"}
   // const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
}
// Function to add imageSrc based on tierName
function addImageSrc(tier) {
  switch (tier.tierName) {
    case "Red":
      tier.imageSrc = crownRedImg;
      break;
    case "Gold":
      tier.imageSrc = crownGoldImg;
      break;
    case "Platinum":
      tier.imageSrc = crownPlatinumImg;
      break;
    case "PlatinumPro":
    case "Platinum Pro":
      tier.imageSrc = crownPlatinumProImg;
      break;
    default:
     // Default image if tierName is not "Red", "Gold", "Platinum", or "PlatinumPro"
      tier.imageSrc = crownRedImg;
  }
}
function addColorTier(tier) {
  switch (tier.tierName) {
    case "Red":
      return "rewards-red-tier";
      break;
    case "Gold":
      return "rewards-gold-tier";
      break;
    case "Platinum":
      return "rewards-platinum-tier";
      break;
    case "PlatinumPro":
    case "Platinum Pro":
      return "rewards-platinum-pro-tier";
      break;
    default:
      // Default image if tierName is not "Red", "Gold", "Platinum", or "PlatinumPro"
       return "rewards-red-tier";
  }
}

function formatNumber(number) {
    return number.toLocaleString();
}
function initializeDataTable() {
  return $('#data-table').DataTable({
        searching: true,
        paging: false,
        lengthMenu: [5, 10, 25, 50],
        pageLength: 10,
        lengthChange: false,
        pagingType:"simple_numbers",
        language: {
          searchPlaceholder: "Search Codes",
          search: ""
        },
    columnDefs: [
            { type: 'date', targets: 2 } // Specify the type of the third column (date)
        ],
     order: [[2, 'desc']] // Automatically sort the third column (date column) in descending order
    });
}

 function openPopup() {
   document.getElementById("redeemButton").disabled = false;
   document.getElementById("generateButton").disabled = false;
    document.querySelector('#error-point-input').innerHTML = "";
    document.querySelector('#error-location').innerHTML = "";
    document.getElementById("popup").classList.add("active");
    document.getElementById("onlineRadio").checked = true;
    updateOptions();
}

  function closePopup(popup) {
   document.getElementById(popup).classList.remove("active");
  if(popup == 'popupConfirmation'){
    document.getElementById("generateButton").disabled = false;
  }
  }
  function updateOptions() {
    var storeDrpdwn = document.getElementById("store-dropdown");

    var onlineRadio = document.getElementById("onlineRadio");
    var storeRadio = document.getElementById("storeRadio");

    if (onlineRadio.checked) {
        storeDrpdwn.style.display = "none";
    } else if (storeRadio.checked) {
        storeDrpdwn.style.display = "block";
    }
  }

  function generateCoupounCode(){
    document.querySelector('#error-point-input').innerHTML = "";
    document.querySelector('#error-location').innerHTML = "";
    document.getElementById("generateButton").disabled = true;
    let selectStoreType = $('input[name="mode"]:checked').val();
    if(selectStoreType != 'online'){
      if($('#location-dropdown').val()== '' || $('#location-dropdown').val()== null){
        document.querySelector('#error-location').innerHTML = "Please select a store";
        document.getElementById("generateButton").disabled = false;
        return;
      }
    }
    if($('#pointsInputStore').val()== '' || $('#pointsInputStore').val()== null){
        document.querySelector('#error-point-input').innerHTML = "Please enter a valid value to redeem";
        document.getElementById("generateButton").disabled = false;
        return;
      }
    document.getElementById("popupConfirmation").classList.add("active");
  }
  function redeemButton(){
    document.getElementById("redeemButton").disabled = true;
    let storeId;
    let obj = {
      customerEmail: email,
      firstName:firstName,
      lastName:lastName,
      redeemPoints:$('#pointsInputStore').val(),
      storeId:null,
      customerId:null
    };
    let selectStoreType = $('input[name="mode"]:checked').val();
    if(selectStoreType == 'online'){
      obj.storeId = getStoreId("Online");
      obj.customerId = customerId;
    }else{
      obj.storeId = $('#location-dropdown').val();
      obj.customerId = null;
    }
    
    fetch(apiEndPoint+'buyerLoyalty/create-discount-code', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(obj) // Convert the data to JSON format
    })
    .then(response => response.text())
    .then(data => {
         $('#new-coupon-code').val(data); 
         closePopup('popup');
         closePopup('popupConfirmation');
         let remainingPointAfterRedeem = parseInt(buyerObject.buyerEligiblePoints) - parseInt($('#pointsInputStore').val());
         document.querySelector('#success-points-remaining').innerHTML = `You have ${remainingPointAfterRedeem} points remaining`;
         document.getElementById("popupSuccess").classList.add("active");
    })
    .catch(error => {
        console.error('Error:', error);
    });
  }
function getStoreId(storeName) {
    const store = stores.find(s => s.storeName.toLowerCase().includes(storeName.toLowerCase()));
    return store ? store.storeId : null;
}
function closeAfterGeneratingCoupon() {
  closePopup('popupSuccess');
  location.reload();
}
function copyOrderNumberToClipBoard(params,element) {
   navigator.clipboard.writeText(params)
        .then(() => showCopyTooltip(element))
        .catch(err => console.error('Unable to copy to clipboard', err));
}

function showCopyTooltip(element) {
    var tooltip = element.nextElementSibling;
    tooltip.style.visibility = 'visible';
    setTimeout(function() {
        tooltip.style.visibility = 'hidden';
    }, 1000); // Hide the tooltip after 1 second
}
 function validateNumber(input) {
    if(input.value == ""){
      document.getElementById('info-point-value').innerHTML = "100 points = $1.00"
    }
    var inputValue = input.value;
    var totalPoints = buyerObject.buyerEligiblePoints || 0;
    if (/^\d+$/.test(inputValue)) {
      var numericValue = parseInt(inputValue);
      if (numericValue > 0 && numericValue <= totalPoints) {
        let newvalue = numericValue/100;
        document.getElementById('info-point-value').innerHTML = `${numericValue} points = $${newvalue}`
      } else {
          input.value = inputValue.slice(0, -1);
      }
  } else {
      input.value = inputValue.slice(0, -1);
  }
}